import { getPhoneStyles } from './phone';
import { getTabletDesktopStyles } from './tablet-desktop/getTabletDesktopStyles';
export function getDeviceStylesIdentity(deviceType, size) {
  if (deviceType === 'phone') {
    return deviceType;
  }

  return size;
}
export function getDeviceStyles(deviceType, size) {
  if (deviceType === 'phone') {
    return getPhoneStyles();
  }

  return getTabletDesktopStyles(size);
}